import { ref, reactive, watch, onMounted } from 'vue'
import { GetImageUrl } from "~/javascripts/utils.js";
import axios from 'axios';
import swal from 'sweetalert';

const features = [
  {id: 1, name: '更換商品', src: GetImageUrl('tools/jacket.png'), main: true, component: 'ChangeProductModal', notInPanel: true},
  {id: 2, name: '添加模版', src: GetImageUrl('tools/image_icon.png'), main: true, component: 'AddModule', notInPanel: false},
  {id: 3, name: '上傳檔案', src: GetImageUrl('tools/upload_icon.png'), main: true, component: 'UploadImage', notInPanel: false},
  {id: 4, name: '添加文字', src: GetImageUrl('tools/text.png'), main: true, component: 'AddText', notInPanel: false},
  {id: 5, name: '產品顏色', src: GetImageUrl('tools/color.png'), component: 'ProductColor', notInPanel:false}
]

const objFields = {
  uploadObj: ["image_id", "design_type", "image_url", "imageHeight", "imageWidth", "text", "textColor", "font_family", "imageColors", "letter_spacing"],
  activeObj: ["id", "design_type", "imageHeight", "imageWidth", "text", "textColor", "font_family", "angle", "imageColors", "image_id", "boundWidthCm", "boundHeightCm", "inputWidthCm", "inputHeightCm", "letter_spacing"]
}

const featureData = reactive({
  featureId: NaN,
  variantId: NaN,
  panelTitle: "",
  moduleChildPanel: false,
  uploadObj: {},
  activeObj: {},
  uploadFiles: sessionStorage.getItem('uploadFiles') ? JSON.parse(sessionStorage.getItem('uploadFiles')) : [],
  showInPanel: true
})

const isMobile = ref()
const maxWidth = ref()

const panelOperationEvent = reactive({
  event: "",
  options: null,
});

const setFeatureData = (key, value) => {
  if (typeof featureData[key] == "object") {
    let newObj = {}

    Object.keys(value).filter(x => objFields[key].includes(x)).forEach(key => {
      newObj[key] = value[key]
    })

    Object.assign(featureData[key], newObj)
  } else {
    featureData[key] = value
  }
}

const initFeatureObj = (objName) => {
  objFields[objName].forEach(key => {
    featureData[objName][key] = null
  })
}

const changeFeature = (componentName) => {
  featureData.featureId = features.find(x => x.component == componentName)?.id
}

const changeIsMobile = (value) => {
  isMobile.value = value
}

const changeMaxWidth = (value) => {
  maxWidth.value = value
}

const handleUpload = async (file) => {
  // 在這裡處理上傳檔案的邏輯，例如將檔案上傳到伺服器等
  console.log('上傳的檔案:', file);
  if(!file) return;
  var formData = new FormData
  formData.append('image', file)

  try {
    let resp = await axios.post('/api/designs/upload_image', formData);
    if (resp.status == 200) {
      featureData.uploadFiles.push(resp.data.design_image)

      setFeatureData('uploadObj', Object.assign(resp.data.design_image, {design_type: 'image'}))
    }
  } catch (e) {
    // TODO 整合
    if (e.response && e.response.status && e.response.status !== 422) {
      swal({title: "非預期錯誤", text: "請聯絡管理人員(errcode 01)", dangerMode: true});
    } else if (e.response && e.response.data && e.response.data.message) {
      swal({title: "提醒", text: e.response.data.message, dangerMode: true});
    } else {
      swal({title: "非預期錯誤", text: "請聯絡管理人員(errcode 02)", dangerMode: true})
    }
  }
};

const isTextType = (designType) => {
  return designType == "text" || designType == "vertical_text";
}

const isVerticalText = (designType) => {
  return designType == "vertical_text";
}

const isValidTextImage = async (text, color, font, angle = 0, imageHeight = null) => {
  let textImage = imageHeight ?
      `/api/designs/text?color=${color.replace('#', '%23')}&font_family=${font}&text=${encodeURIComponent(text)}&height=${imageHeight}&max_width=${maxWidth.value}&angle=${angle}` :
      `/api/designs/text?color=${color.replace('#', '%23')}&font_family=${font}&text=${encodeURIComponent(text)}&max_width=${maxWidth.value}&angle=${angle}`
    
  try {
    const response = await fetch(textImage, { method: 'HEAD' }); // 使用 HEAD 方法僅請求資源的標頭
    if (!response.ok) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
}

const isValidVerticalTextImage = async (text, color, font, angle = 0, imageWidth = null, letterSpacing = 0) => {
  let textImage = imageWidth ?
      `/api/designs/vertical_text?color=${color.replace('#', '%23')}&font_family=${font}&text=${encodeURIComponent(text)}&width=${imageWidth}&letter_spacing=${letterSpacing}&max_width=${maxWidth.value}&angle=${angle}` :
      `/api/designs/vertical_text?color=${color.replace('#', '%23')}&font_family=${font}&text=${encodeURIComponent(text)}&letter_spacing=${letterSpacing}&max_width=${maxWidth.value}&angle=${angle}`
    
  try {
    const response = await fetch(textImage, { method: 'HEAD' }); // 使用 HEAD 方法僅請求資源的標頭
    if (!response.ok) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
}

const getTextImage = async (text, color, font, angle = 0, imageHeight = null) => {
  let textImage = imageHeight ?
      `/api/designs/text?color=${color.replace('#', '%23')}&font_family=${font}&text=${encodeURIComponent(text)}&height=${imageHeight}&max_width=${maxWidth.value}&angle=${angle}` :
      `/api/designs/text?color=${color.replace('#', '%23')}&font_family=${font}&text=${encodeURIComponent(text)}&max_width=${maxWidth.value}&angle=${angle}`

  let textObj = {
    image_id:    null,
    image_url:   textImage,
    design_type: 'text',
    text:        text,
    textColor:   color,
    font_family: font,
    imageHeight: imageHeight
  }

  setFeatureData('uploadObj', textObj);
}

const getVerticalTextImage = async (text, color, font, angle = 0, imageWidth = null, letterSpacing = 0) => {
  let textImage = imageWidth ?
      `/api/designs/vertical_text?color=${color.replace('#', '%23')}&font_family=${font}&text=${encodeURIComponent(text)}&width=${imageWidth}&letter_spacing=${letterSpacing}&max_width=${maxWidth.value}&angle=${angle}` :
      `/api/designs/vertical_text?color=${color.replace('#', '%23')}&font_family=${font}&text=${encodeURIComponent(text)}&letter_spacing=${letterSpacing}&max_width=${maxWidth.value}&angle=${angle}`

  let textObj = {
    image_id:    null,
    image_url:   textImage,
    design_type: 'vertical_text',
    text:        text,
    textColor:   color,
    font_family: font,
    imageWidth:  imageWidth,
    letter_spacing: letterSpacing
  }

  setFeatureData('uploadObj', textObj);
}

const getModule = async (id) => {
  try {
    const resp = await axios.get(`/api/materials/${id}/design_material_get_image`);
    const data = {
      image_id    : id,
      image_url   : resp.data.image.url,
      imageColors : resp.data.image.colors
    }
    changeModuleColors(data.image_id, data.imageColors);
  } catch(err) {
    console.log(err)
  }
}

const changeModuleColors = (id = null, colors = []) => {
  const params = colors.map(color => `current_colors[]=${encodeURIComponent(color.code)}`).join('&');
  try {
    const data = {
      image_id    : id,
      image_url   : `/api/materials/${id}/design_material_change_color?${params}`,
      imageColors : colors
    }
    setFeatureData('uploadObj', Object.assign(data, {design_type: 'svgImage'}));
  } catch(err) {
    console.log(err)
  }
}

const setScollTop = (component = null) => {
  if(component) component.scrollTo(0,0);
}

const handleAlignClick = () => {
  panelOperationEvent.event = "align";
  panelOperationEvent.options = {method: 'center'};
}

const changeTextSize = (side, newSideValue, currentText, curretTextColor, currentFontFamily, isVertical) => {
  panelOperationEvent.event = "resize"
  panelOperationEvent.options = {side, newSideValue, isText: true, isVertical, currentText, curretTextColor, currentFontFamily}
}

const changeTextDirection = (designType, currentText, curretTextColor, currentFontFamily) => {
  panelOperationEvent.event = "flip"
  panelOperationEvent.options = {designType, currentText, curretTextColor, currentFontFamily}
}

const changeVerticalTextLetterSpacing = (currentText, curretTextColor, currentFontFamily, angle, imageWidth, letterSpacing) => {
  panelOperationEvent.event = "spacing"
  panelOperationEvent.options = {currentText, curretTextColor, currentFontFamily, angle, imageWidth, letterSpacing}
}

const changeFabricImageSize = (side, newSideValue) => {
  panelOperationEvent.event = "resize"
  panelOperationEvent.options = {side, newSideValue}
}

const hasFocusedInput = ref(false);

const setFocusedInput = (event) => {
  event.target.classList.add("js-dl-panel-input-focuse");
  hasFocusedInput.value = true;
};

const clearFocusedInput = (event) => {
  event.target.classList.remove("js-dl-panel-input-focuse");
  hasFocusedInput.value = false;
};

// TODO: 目前用lock的方式處理module上傳異步問題
let moduleColorLock = ref(false);

watch(() => featureData.featureId, (newVal) => {
  featureData.panelTitle = features.find(x => x.id == newVal)?.name
  featureData.moduleChildPanel = false;
  if(newVal) {
    var currentFeature = features.find(x => x.id == newVal)
    setFeatureData('showInPanel', !currentFeature.notInPanel)
  }
})

watch(() => featureData.uploadFiles, (newVal) => {
  sessionStorage.setItem('uploadFiles', JSON.stringify(newVal))
}, {
  deep: true
})

watch(() => featureData.activeObj, (newVal) => {
  console.log(newVal)
}, {
  deep: true
})


export {
  features,
  featureData,
  isMobile,
  maxWidth,
  moduleColorLock,
  panelOperationEvent,
  hasFocusedInput,
  setFeatureData,
  initFeatureObj,
  changeFeature,
  changeIsMobile,
  changeMaxWidth,
  handleUpload,
  isTextType,
  isVerticalText,
  isValidTextImage,
  isValidVerticalTextImage,
  getTextImage,
  getVerticalTextImage,
  getModule,
  changeModuleColors,
  setScollTop,
  handleAlignClick,
  changeTextSize,
  changeTextDirection,
  changeVerticalTextLetterSpacing,
  changeFabricImageSize,
  setFocusedInput,
  clearFocusedInput,
}
